import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { su } from '../../theme/functions/su';
import { theme } from '../../theme/theme';

import { Glyph } from './Glyph';
import { Heading2Medium } from './text/Heading2Medium';
import { ParagraphRegular } from './text/ParagraphRegular';
import { TextRegular } from './text/TextRegular';

/**
 * Render a message in the center of the parent container with an optional icon and action.
 */
export function CenteredMessage(props) {
  return (
    <CenteredMessage.Root>
      {props.icon}

      {props.iconUrl && (
        <CenteredMessage.Icon
          size="40px"
          color={props.iconColor ?? theme.color.text}
          source={props.iconUrl}
        />
      )}

      {props.title && (
        <CenteredMessage.Title color={props.titleColor}>{props.title}</CenteredMessage.Title>
      )}

      {props.subtitle && (
        <CenteredMessage.Subtitle textAlign="center" color={props.subtitleColor}>
          {props.subtitle}
        </CenteredMessage.Subtitle>
      )}

      <div>
        <ParagraphRegular>{props.action}</ParagraphRegular>
      </div>

      {props.children}
    </CenteredMessage.Root>
  );
}

CenteredMessage.propTypes = {
  iconUrl: PropTypes.string,
  iconColor: PropTypes.string,
  title: PropTypes.any,
  titleColor: PropTypes.string,
  subtitle: PropTypes.any,
  subtitleColor: PropTypes.string,
  action: PropTypes.any,
  children: PropTypes.any,
  icon: PropTypes.any,
};

CenteredMessage.Root = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

CenteredMessage.Icon = styled(Glyph)`
  margin-top: ${su(1)};
`;

CenteredMessage.Title = styled(Heading2Medium)`
  margin-top: ${su(1)};
`;

CenteredMessage.Subtitle = styled(TextRegular)`
  max-width: 600px;
  margin: ${su(1, 0)};
`;
